import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import ReactDom from 'react-dom';
import {StyleRoot} from 'radium';
import {push} from 'react-router-redux';
import {setSelectedItems} from '../tree/actions';
import SchoolSchoolReport from './reports/school_school';
import SchoolQuestionsReport from './reports/school_questions';
import StudentReport from './reports/student';
import PrintStudentReport from './reports/print_student';
import {request} from '../../containers/actions';
import Tree from '../tree';
import SchoolManagerReport from './reports/school_manager';

import queryString from 'query-string';
import * as actions from './actions';
import * as defaultStyles from '../../styles';

export default class EssayReport extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    state = {
        currentTab: 0,
        showSchools: false,
    }

    async componentDidMount() {
        await this.context.store.dispatch(setSelectedItems(
            [],
            'schools',
            this.props.schoolsTree.elementId,
        ));
        this.fetch.bind(this)();
        this.fetchReport.bind(this)();
    }

    componentWillReceiveProps(nextProps) {
        if (!_.isEqual(_.keys(nextProps.regionsTree.selected), _.keys(this.props.regionsTree.selected))) {
            this.context.store.dispatch(setSelectedItems(
                [],
                'cities',
                this.props.citiesTree.elementId,
            ));
        }
        else if (!_.isEqual(_.keys(nextProps.citiesTree.selected), _.keys(this.props.citiesTree.selected))) {
            this.context.store.dispatch(setSelectedItems(
                [],
                'schools',
                this.props.schoolsTree.elementId,
            ));
        }
        if (nextProps.params.examinationId !== this.props.params.examinationId) {
            this.context.store.dispatch(setSelectedItems(
                [],
                'schools',
                this.props.schoolsTree.elementId,
            ));
        }
    }

    componentDidUpdate(prevProps) {
        let prevSchool = _.keys(prevProps.schoolsTree.selected)[0];
        if (
            this.context.store.getState().getIn(['application', 'user', 'type']) === 'manager' &&
            _.keys(prevProps.schoolsTree.items.school).length
        )
            prevSchool = _.values(prevProps.schoolsTree.items.school)[0].id;
        let currentSchool = _.keys(this.props.schoolsTree.selected)[0];
        if (
            this.context.store.getState().getIn(['application', 'user', 'type']) === 'manager' &&
            _.keys(this.props.schoolsTree.items.school).length
        )
            currentSchool = _.values(this.props.schoolsTree.items.school)[0].id;
        if (
            (prevProps.main.examination && prevProps.main.examination.id) !==
            (this.props.main.examination && this.props.main.examination.id) ||
            prevSchool !== currentSchool
        ) {
            this.fetchReport.bind(this)();
        }
    }

    async fetch() {
        this.context.store.dispatch(actions.setExamination(
            {},
            this.props.main.elementId,
        ));
        const response = await this.context.store.dispatch(request(
            `/examination/${this.props.params.examinationId}/?detailed&report&react__route=${window.location.pathname}`,
        ));
        this.context.store.dispatch(actions.setExamination(
            response,
            this.props.main.elementId,
        ));
    }

    fetchReport() {
        this.setState({results: undefined, data: undefined, students: {}});
        let school = _.keys(this.props.schoolsTree.selected)[0];
        if (
            this.context.store.getState().getIn(['application', 'user', 'type']) === 'manager' &&
            _.keys(this.props.schoolsTree.items.school).length
        )
            school = _.values(this.props.schoolsTree.items.school)[0].id;
        if (!this.props.main.examination || _.keys(this.props.main.examination).length === 0 || !school)
            return;
        (async () => {
            const response = await this.context.store.dispatch(request({
                path: '/result/?' + queryString.stringify({
                    examination: this.props.main.examination.id,
                    school,
                    report: null,
                    limit: 10000,
                }),
            }));
            this.setState({
                results: response.results,
            });
        })();
        (async () => {
            const response = await this.context.store.dispatch(request({
                path: '/student/?' + queryString.stringify({
                    examination: this.props.main.examination.id,
                    school,
                    report: null,
                    limit: 300,
                }),
            }));
            this.setState({
                students: response.results,
            });
        })();
        (async () => {
            const response = await this.context.store.dispatch(request({
                path: '/data/?' + queryString.stringify({
                    examination: this.props.main.examination.id,
                    school,
                    limit: 20000,
                    ...(this.props.student
                        ? {student: this.props.student}
                        : {}
                    ),
                }),
            }));
            this.setState({
                data: response.results,
            });
        })();
    }

    render() {
        if (!this.props.main.examination ||
            !this.props.main.examination.id ||
            this.props.main.examination.id.toString() !== this.props.params.examinationId)
            return null;
        if (this.props.module === 'student' || this.props.params.studentId)
            return <StudentReport
                examination={this.props.main.examination}
                student={this.props.params.studentId}
                back={this.props.urls.back.format(this.props.params)}
            />;
        let school = _.keys(this.props.schoolsTree.selected)[0];
        if (
            this.context.store.getState().getIn(['application', 'user', 'type']) === 'manager' &&
            _.keys(this.props.schoolsTree.items.school).length
        )
            school = _.values(this.props.schoolsTree.items.school)[0].id;
        return <div>
            {this.context.pending
                ? null
                : <div style={{position: 'relative'}}>
                    <div
                        style={{
                            position: 'absolute',
                            right: '60%',
                            transform: 'translateX(50%)',
                            marginTop: '-.25em',
                            fontWeight: '500',
                            fontSize: '1.4em',
                        }}>
                        {this.props.main.examination ? this.props.main.examination.title : null}
                    </div>
                    <button
                        key='0'
                        style={
                            this.state.currentTab === 0
                                ? defaultStyles.activeTabButton
                                : defaultStyles.tabButton
                        }
                        onClick={() => this.setState({currentTab: 0})}>
                        {window.gettext('Manager Report')}
                    </button>
                    <button
                        key='1'
                        style={
                            this.state.currentTab === 1
                                ? defaultStyles.activeTabButton
                                : defaultStyles.tabButton
                        }
                        onClick={() => this.setState({currentTab: 1})}>
                        {window.gettext('School Report')}
                    </button>
                    <button
                        key='2'
                        style={
                            this.state.currentTab === 2
                                ? defaultStyles.activeTabButton
                                : defaultStyles.tabButton
                        }
                        onClick={() => this.setState({currentTab: 2})}>
                        {window.gettext('Class Report')}
                    </button>
                    <button
                        key='3'
                        style={
                            this.state.currentTab === 3
                                ? defaultStyles.activeTabButton
                                : defaultStyles.tabButton
                        }
                        onClick={() => this.setState({currentTab: 3})}>
                        {window.gettext('Teacher Report')}
                    </button>
                    {this.context.store.getState().getIn(['application', 'user', 'type']) !== 'manager'
                        ? <button
                            key='4'
                            style={
                                this.state.currentTab === 4
                                    ? defaultStyles.activeTabButton
                                    : defaultStyles.tabButton
                            }
                            onClick={() => this.setState({currentTab: 4})}>
                            {window.gettext('Client Report')}
                        </button>
                        : null
                    }
                    <button
                        key='close'
                        style={{
                            ...defaultStyles.button,
                            float: 'left',
                            marginRight: '.5em',
                        }}
                        onClick={() => this.context.store.dispatch(push(this.props.urls.back.format(this.props.params)))}>
                        {window.gettext('Back')}
                    </button>
                    <iframe
                        ref='print'
                        style={{width: '0', height: '0', border: 'none'}}
                        srcDoc={`<html>
    <head>
        <link rel="stylesheet" type="text/css" href="/css/mhelli.css">
        <style>
            @page {
                size: A4 Landscape;
                margin: 0;
            }
            body {
                background-color: white;
            }
        </style>
    </head>
    <body dir='rtl'>
        <span id='content'>
            <span style='font-family: IRANSans;'>1</span>
            <span style='font-family: IRANSans; font-weight: 700;'>1</span>
        </span>
    </body>
</html>`}/>
                    {this.state.printing
                        ? <i className='fa-spin fa-spinner fa-2x'></i>
                        : school
                            ? <button
                                key='print'
                                style={{
                                    ...defaultStyles.defaultButton,
                                    float: 'left',
                                    marginRight: '.5em',
                                }}
                                onClick={async () => {
                                    this.setState({printing: true});
                                    const win = this.refs.print.contentWindow;
                                    let imageCounter = 0;
                                    alert(window.gettext('Print Tutorial'));
                                    win.document.getElementById('content').innerHTML = '';
                                    let counter = 0;
                                    const students = _.filter(
                                        this.state.students,
                                        student => _.some(this.state.data, item => item.student === student.id),
                                    );
                                    ReactDom.render(<StyleRoot>
                                        {_.map(students, student => <PrintStudentReport
                                            key={student.id}
                                            last={++counter === _.size(students)}
                                            examination={this.props.main.examination}
                                            results={_.filter(this.state.results, result => result.student === student.id)}
                                            data={this.state.data}
                                            student={student}
                                            school={this.props.schoolsTree.items.school[school]}
                                            imageLoaded={() => {
                                                imageCounter++;
                                                if (imageCounter === _.size(students)) {
                                                    win.print();
                                                    this.setState({printing: false});
                                                }
                                            }}
                                        />)}
                                    </StyleRoot>, win.document.getElementById('content'));
                                }}>
                                {window.gettext('Print Students Reports')}
                            </button>
                            : null
                    }
                </div>
            }
            <div
                style={{
                    marginTop: '.5em',
                    display: (
                        this.state.currentTab !== 4 &&
                        this.context.store.getState().getIn(['application', 'user', 'type']) === 'manager'
                    ) ? 'none' : undefined,
                }}>
                {this.props.main.examination && this.props.main.examination.id
                    ? [
                        <div key='region' style={treeStyle}>
                            <Tree
                                {...this.props.regionsTree}
                                readonly={true}
                                resource='region'
                                tree={false}
                                itemLabel='name'
                                multiSelection={false}
                                combobox={true}
                                label={window.gettext('Region')}
                                filter={{papers_examinations: this.props.main.examination.id}}
                            />
                        </div>,
                        <div key='city' style={treeStyle}>
                            <Tree
                                {...this.props.citiesTree}
                                readonly={true}
                                resource='city'
                                tree={false}
                                itemLabel={city =>
                                    `${city.region_display} - ${city.name}`}
                                multiSelection={false}
                                combobox={true}
                                label={window.gettext('City')}
                                filter={{
                                    region: _.keys(this.props.regionsTree.selected).join(','),
                                    papers_examinations: this.props.main.examination.id,
                                }}
                            />
                        </div>,
                        <div key='school' style={{...treeStyle, width: '35%'}}>
                            <Tree
                                {...this.props.schoolsTree}
                                readonly={true}
                                resource='school'
                                tree={false}
                                itemLabel={school =>
                                    `${school.city.name} - ${school.name} - ` +
                                    `${_.map(school.levels, level => level.title).join(window.gettext(',') + ' ')}`
                                }
                                multiSelection={false}
                                combobox={true}
                                label={window.gettext('School')}
                                filter={{
                                    region: _.keys(this.props.regionsTree.selected).join(','),
                                    city: _.keys(this.props.citiesTree.selected).join(','),
                                    papers_examinations: this.props.main.examination.id,
                                }}
                            />
                        </div>,
                    ]
                    : null
                }
            </div>
            {school
                ? <div style={{fontSize: '.9em', clear: 'right', marginTop: '.5em'}}>
                    {this.state.currentTab === 0
                        ? <SchoolManagerReport
                            examination={this.props.main.examination}
                            school={this.props.schoolsTree.items.school[school]}
                            data={this.state.data}
                            students={this.state.students}
                            results={this.state.results}
                        />
                        : this.state.currentTab === 1
                            ? <SchoolSchoolReport
                                examination={this.props.main.examination}
                                school={this.props.schoolsTree.items.school[school]}
                                data={this.state.data}
                            />
                            : this.state.currentTab === 2
                                ? <SchoolSchoolReport
                                    examination={this.props.main.examination}
                                    school={this.props.schoolsTree.items.school[school]}
                                    classView
                                    data={this.state.data}
                                />
                                : this.state.currentTab === 3
                                    ? <SchoolQuestionsReport
                                        examination={this.props.main.examination}
                                        school={this.props.schoolsTree.items.school[school]}
                                        data={this.state.data}
                                    />
                                    : null
                    }
                </div>
                : null
            }
        </div>;
    }
}

const treeStyle = {
    fontSize: '.8em',
    width: 'calc(25% - 1em)',
    marginBottom: '1em',
    marginLeft: '.5em',
    marginRight: '.5em',
    float: 'right',
    maxHeight: '25em',
};
